<div class="header-controls-container">
  <!-- Social Links -->
  @if (showSocialLinks && socialLinks.length > 0) {
    <div class="social-links">
      <div class="social-icons-wrapper">
        @for (socialLink of socialLinks; track socialLink) {
          <a
            [href]="socialLink.url"
            target="_blank"
            [title]="socialLink.name"
            class="social-icon"
            (click)="openSocialLink(socialLink.url); $event.preventDefault()">
            <i [class]="socialLink.icon"></i>
          </a>
        }
      </div>
    </div>
  }

  <!-- Language Selector -->
  @if (shouldShowLanguageSelector) {
    <div class="header-lang-switcher">
      <button
        class="header-lang-btn"
        [class.active]="currentLang === 'tr'"
        (click)="setLanguage('tr')">
        TR
      </button>
      <button
        class="header-lang-btn"
        [class.active]="currentLang === 'en'"
        (click)="setLanguage('en')">
        EN
      </button>
    </div>
  }

</div>
